import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { ReciclagemOrigemPage } from "./reciclagem-origem";
import { ParticipacaoProvider } from "../../../providers/participacao/partipacao.provider";
import { ContratoProvider } from "../../../providers/contrato/contrato.provider";

@NgModule({
  declarations: [ReciclagemOrigemPage],
  imports: [IonicPageModule.forChild([ReciclagemOrigemPage])],
  providers: [ParticipacaoProvider, ContratoProvider],
})
export class ReciclagemOrigemPageModule {}



// WEBPACK FOOTER //
// ./src/pages/reciclagem/reciclagem-origem/reciclagem-origem.module.ts